import React, { CSSProperties } from "react";

interface ImageProps {
    src: string;
    alt: string;
    sx?: CSSProperties;
    className?: string;
}

const ImageComponent = (props: ImageProps) => {
    return <img 
        src={props.src}
        alt={props.alt}
        style={props.sx}
        className={props.className}
    />
}

export default ImageComponent;